import React, { useState, useEffect, Fragment } from "react";
import parse from "html-react-parser";
import Slider, { Settings } from "react-slick";
import { hostname } from "../../constants";
import Page from "../../layouts/Page";
import TextBlock from "../../components/TextBlock";
import Button from "../../components/Button";
import MiniAddress from "../../components/MiniAddress";
import styles from "./styles.module.sass";
import ove from "./logo-ove.png";

interface SlideItem {
  image: {
    id: number;
    url: string;
  };
}

interface SpaData {
  acf: {
    intro?: string;
    slide?: SlideItem[];
  };
  content: { rendered: string };
}

const settings: Settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    { breakpoint: 600, settings: { slidesToScroll: 1, initialSlide: 1 } },
  ],
};

const info = {
  address: `Lloyd's Inn Bali, Level 2
        <br />
        Jln Arjuna (Double Six),
        <br />
        Seminyak, Kuta, Kabupaten Badung,
        <br />
        Bali 80361`,
  hours: "9am - 9pm",
  email: "thecanopyspa@lloydsinn.com",
  fb: "https://www.facebook.com/thecanopyspa/",
  ig: "https://instagram.com/thecanopyspa",
  ta: "https://www.tripadvisor.com.au/Attraction_Review-g469404-d17379406-Reviews-The_Canopy_Spa-Seminyak_Kuta_District_Bali.html",
  wa: "+62 877 3038 1582",
};

const Spa: React.FC = () => {
  const [data, setData] = useState<SpaData | null>(null);

  useEffect(() => {
    fetch(`${hostname}/wp-json/wp/v2/pages/73015`)
      .then((res) => res.json())
      .then((json: SpaData) => setData(json))
      .catch(console.error);
  }, []);

  if (!data?.content?.rendered) return null;

  return (
    <Page className={styles.base}>
      <Fragment>
        <TextBlock className={styles.intro} width={725}>
          {data.acf.intro && parse(data.acf.intro)}
          {data.acf?.slide && (
            <Slider className={styles.slider} {...settings}>
              {data.acf.slide.map((slide) => (
                <div key={`slide-${slide.image.id}`}>
                  <img src={slide.image.url} alt="" />
                </div>
              ))}
            </Slider>
          )}
          {parse(data.content.rendered)}
        </TextBlock>
        <br />
        <TextBlock className={styles.note} width={725}>
          <p>The Canopy Spa is a collection by</p>
          <img className={styles.logo} src={ove} alt="Ove" />
          <div className={styles.actions}>
            <Button
              className={styles.btn}
              href="https://www.facebook.com/thecanopyspa/menu/"
            >
              View menu
            </Button>
            <Button className={styles.btn} href="https://wa.link/xee2ep">
              Reservation
            </Button>
          </div>
        </TextBlock>
        <MiniAddress {...info} />
      </Fragment>
    </Page>
  );
};

export default Spa;
